import bulmaCollapsible from '@creativebulma/bulma-collapsible';

document.addEventListener('DOMContentLoaded', () => {
    bulmaCollapsible.attach('.is-collapsible:not(.is-collapsible-vue)');
});